import type {
  ApiFetchHomeMenuPort,
  HomeMenuItem,
} from '~/handlers/ports/api-fetch-home-menu.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiFetchHomeMenuAdapter implements ApiFetchHomeMenuPort {
  async handle(): Promise<HomeMenuItem[]> {
    const response = await fetch(`${getApostatudoApiUrl()}/home-menu`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      console.warn(
        `[ApiFetchHomeMenu] API returned ${response.status}: ${response.statusText}`,
      );

      return [];
    }

    const data = await response.json();

    if (!Array.isArray(data)) {
      console.warn('[ApiFetchHomeMenu] API response is not an array:', data);

      return [];
    }

    return data.map(
      (item: any): HomeMenuItem => ({
        id: item.id ? String(item.id) : '',
        image_url: item.image_url,
        image_bg_color: item.image_bg_color || null,
        image_border_color: item.image_border_color || null,
        title: item.title,
        label: item.label || null,
        label_font_color: item.label_font_color || null,
        label_bg_color: item.label_bg_color || null,
        link_url: item.link_url,
        // Sinal POSITIVO e restritivo: só esconde de quem está deslogado quando
        // o core disser explicitamente `true`. Item sem a flag (ou payload
        // antigo/fallback) continua visível pra todo mundo.
        logged_in_only: item.logged_in_only === true,
        // Aqui o padrão é o inverso: ausente = visível. Só esconde no `false`
        // explícito, senão um payload sem as flags apagaria o menu inteiro.
        visible_on_desktop: item.visible_on_desktop !== false,
        // `visible_on_mobile` é navegador mobile; a WebView do app tem a sua
        // própria flag desde a separação Web/Aplicativo no painel.
        visible_on_mobile: item.visible_on_mobile !== false,
        visible_on_app: item.visible_on_app !== false,
      }),
    );
  }
}
